import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\toutline: none;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css } from '@wp-g2/styles';
import * as baseFieldStyles from '../BaseField/BaseField.styles';
export var SelectDropdown = css(_templateObject());
export var MenuWrapper = css(_templateObject2());
export var DropdownMenu = css(_templateObject3());
export var inline = baseFieldStyles.inline;